// import { ReactComponent as EditIcon } from '@common/icons/Edit.svg';
// import { ReactComponent as ReplyIcon } from '@common/icons/Reply.svg';
// import { ReactComponent as ThumbsUpIcon } from '@common/icons/ThumbsUp.svg';
import React from 'react';

import StarRating from './StarRating';

export interface ReviewProps {
  className?: string;
  rating?: number;
  total?: number;
  name: string;
  date: string;
  review: string;
}

function spliter(dateStr: string) {
  const arr = dateStr.split(' ');
  return arr[2] + ' ' + arr[1] + ', ' + arr[3];
}

const ReviewComponent: React.FunctionComponent<ReviewProps> = ({ name, review, rating, date }) => {
  return (
    <div className={'flex flex-col mb-30 md:min-w-full md:w-full'}>
      <div className="flex flex-col md:flex-row justify-start md:justify-between items-start md:items-center">
        <div className="flex gap-10">
          <div className="text-textColor font-bold text-16 leading-22" color-customisation="page-body-text">
            {name}
          </div>
          {rating != null ? (
            <div className="flex">
              <StarRating rating={rating} total={5} isInteractive={false} className="transform scale-40" />
            </div>
          ) : null}
        </div>
        <div className="text-16 leading-24 font-normal text-disabled mt-4 md:mt-0">{spliter(date)}</div>
      </div>
      <div className="text-16 leading-24 font-normal text-disabled mt-12" color-customisation="page-body-text">
        {review}
      </div>
    </div>
  );
};

export default ReviewComponent;
